module.exports = __webpack_public_path__ + "static/media/alacrity-logo.f2cd21f9.svg";